import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes, AppRoutes } from './app.routes';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthService } from './core/auth/auth.service';
import { AUTH_API_URL, AUTH_REDIRECT_URL, AUTH_TOKEN_URL } from './core/auth/auth.tokens';
import { TranslocoHttpLoader } from './core/i18n/transloco-http-loader';
import { AuthInterceptor } from './core/interceptors/auth/auth.interceptor';
import { ApiErrorInterceptor } from './core/interceptors/api-error/api-error.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { baseUrlInterceptor } from './core/interceptors/base-url/base-url.interceptor';
import { DRIVER_GATEWAY } from '../domains/master-account/getaway/driver.gateway';
import { PageDriverGateway } from '../domains/master-account/getaway/page-driver.gateway';
import { initAuth } from './core/auth/auth.bootstrap';
import { provideTransloco } from '@jsverse/transloco';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(AppRoutes),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        ApiErrorInterceptor,
        AuthInterceptor,
        baseUrlInterceptor,
      ])
    ),
    AuthService,
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
    {
      provide: AUTH_API_URL,
      useValue: '/corporate-client/login',
    },
    {
      provide: AUTH_REDIRECT_URL,
      useValue: appRoutes.auth,
    },
    {
      provide: AUTH_TOKEN_URL,
      useValue: '',
    },
    {
      provide: DRIVER_GATEWAY,
      useClass: PageDriverGateway,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService],
      useFactory: initAuth,
    },
    ConfirmationService,
    MessageService,
    provideTransloco({
      config: {
        availableLangs: ['kz', 'ru', 'tr', 'en'],
        fallbackLang: 'ru',
        defaultLang: 'ru',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
